import { createFileRoute } from '@tanstack/react-router';

import { useAppNavigate } from '../../lib/session/navigate';
import { ReschedulePage } from '../../portal/reschedule-page';

/** `/account/appointments/$id/reschedule` — pick a different time (M10.4, ADR-022). */
export const Route = createFileRoute('/account/appointments/$id/reschedule')({
  component: RescheduleRoute,
});

function RescheduleRoute() {
  const { id } = Route.useParams();
  const navigate = useAppNavigate();

  return (
    <ReschedulePage
      appointmentId={id}
      onFinished={() => {
        navigate('/account');
      }}
    />
  );
}
